import { SpaceType } from "@components/atoms/Spacer/types";
import Routes from "@navigations/Routes";
import { DefaultTheme } from "styled-components/native";

export const MAX_DRAWER_WIDTH = 400;
export const MAX_WEB_DRAWER_WIDTH = 381;
export const MAX_DRAWER_PERCENTAGE = 0.35;

export const chatBotConfig = {
  floatingButtonVisibility: {
    enabledPriceModes: [1],
  },
};

export const getDrawerWidth = (
  screenSize: number,
  theme: DefaultTheme,
  screenName?: string
) => {
  const maxWidth = theme.isLargeScreen
    ? screenName === Routes.FilterSplitScreen
      ? MAX_WEB_DRAWER_WIDTH + SpaceType.large
      : MAX_WEB_DRAWER_WIDTH
    : MAX_DRAWER_WIDTH;
  return screenSize * MAX_DRAWER_PERCENTAGE > maxWidth
    ? maxWidth
    : screenSize * MAX_DRAWER_PERCENTAGE;
};
